// src/main.ts
import { createApp } from "vue";
import i18n from "./i18n";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import http from "./api/http"; // si utilisé par d'autres singletons, on garde
import 'flag-icons/css/flag-icons.min.css' 
// Styles globaux
import "@/assets/main.css";

// Toastification
import Toast, {
  createToastInterface,
  POSITION,
  type PluginOptions,
} from "vue-toastification";
import "vue-toastification/dist/index.css";
import "@/assets/toast-premium.css";
import CustomToast from "@/components/CustomToast.vue";

// State
import { createPinia } from "pinia";
import { useInbox } from "./store/inbox";

// Realtime (admin uniquement)
import { setupRealtimeForAdmin, isAdminContext } from "@/realtime-admin";

// // ------------------------------------------------------------------
// // Bases d’URL (Vue CLI => process.env.VUE_APP_*)
// // .env.development doit contenir, sans /api final:
// //   VUE_APP_API_BASE=http://10.0.0.47:5001
// //   VUE_APP_UPLOADS_ORIGIN=http://10.0.0.47:5001
// // ------------------------------------------------------------------
// const API_BASE = String(
//   process.env.VUE_APP_API_BASE || window.location.origin
// ).replace(/\/+$/, "");
// const UPLOADS_ORIGIN = String(
//   process.env.VUE_APP_UPLOADS_ORIGIN || process.env.VUE_APP_API_BASE || API_BASE
// ).replace(/\/+$/, "");

// ------------------------------------------------------------------
// Bases d’URL (CORRIGÉ pour éviter le doublon )
// ------------------------------------------------------------------
// --- Configuration des bases d'URL (Version Sécurisée) ---
const API_BASE = String(
  process.env.VUE_APP_API_BASE || window.location.origin
)
  .replace(/\/+$/, "")      // Supprime les slashs de fin
  .replace(/\/api$/, "");   // 🛡️ SÉCURITÉ : Supprime /api s'il est déjà présent

const UPLOADS_ORIGIN = String(
  process.env.VUE_APP_UPLOADS_ORIGIN || process.env.VUE_APP_API_BASE || API_BASE
)
  .replace(/\/+$/, "")
  .replace(/\/api$/, "");   // Nettoie aussi l'origine des uploads


// Expose pour modules qui lisent window.*
(window as any).__API_BASE__ = API_BASE;
(window as any).__UPLOADS_ORIGIN__ = UPLOADS_ORIGIN;

// --- Options Toast “premium” ---
const toastOptions: PluginOptions = {
  position: POSITION.TOP_RIGHT,
  timeout: 2100,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.5,
  hideProgressBar: false,
  closeButton: false,
  icon: true,
  newestOnTop: true,
  maxToasts: 5,
  transition: "Vue-Toastification__fade",
  toastClassName: "toast-premium",
  bodyClassName: "toast-premium__body",
  containerClassName: "toast-premium__container",
};

// ------------------------------------------------------------------
// Boot
// ------------------------------------------------------------------
const app = createApp(App);
const pinia = createPinia();

app.use(pinia).use(store).use(router).use(i18n).use(Toast, toastOptions);
app.mount("#app");

// ------------------------------------------------------------------
// Realtime admin (SSE + Socket.IO) — déplacé dans realtime-admin.ts
// ------------------------------------------------------------------
if (isAdminContext()) {
  const toast = createToastInterface(toastOptions);
  const inbox = useInbox();

  setupRealtimeForAdmin({
    store: store as any,
    inbox,
    toast,
    CustomToast,
    apiBase: API_BASE,
  });
}

// ------------------------------------------------------------------
// Token expiré → ménage régulier
// ------------------------------------------------------------------
setInterval(() => {
  const tok = localStorage.getItem("auth_token");
  if (!tok) return;
  try {
    const payload = JSON.parse(atob(tok.split(".")[1]));
    if (Date.now() >= payload.exp * 1000) {
      localStorage.removeItem("auth_token");
      if (location.pathname.startsWith("/admin")) {
        location.href = "/login";
      }
    }
  } catch {
    /* ignore */
  }
}, 5 * 60 * 1000);

// Petit log de sanity
console.log("[BOOT] API_BASE =", API_BASE, "| UPLOADS_ORIGIN =", UPLOADS_ORIGIN);
